import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import { getBasicActivity } from '../../actions/common'
import { getActivity, deleteActivity } from '../../actions/activity'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'


export default function Activity() {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { list, loading } = useSelector(state => state.activity)
  const { basicActivity } = useSelector(state => state.common)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getBasicActivity());
    dispatch(getActivity());
  }, [])

  const basicActivityObj = basicActivity?.reduce((acc, el) => ({ ...acc, [el.id]: el.name }), {}) || {}

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteActivity(confirmation.id));
    setConfirmation(false);
  };

  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { id, name, basic_activity, cpa } = data
    return (
      <tr>
        <td onClick={openModal(data)}>{name}</td>
        <td onClick={openModal(data)}>{basicActivityObj[basic_activity]}</td>
        <td onClick={openModal(data)}>{cpa}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id, name })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          // confirmation={confirmation?.name} 
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <Modal
        closeModal={closeModal}
        data={selectedItem}
      />
      <header className={styles.header}>
        <h1>Активности</h1>
      </header>
      <main className={styles.content}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Активность</th>
              <th>Вид активности</th>
              <th>КФА</th>
              <th style={{ width: '60px' }}></th>
            </tr>
          </thead>
          <tbody>
            {list?.map(renderLi)}
          </tbody>
        </Table>
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal()}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего записей: {list?.length || 0}</span>
        </div>
      </main>
    </div>
  )
}
